import Loader, { DotsLoader, DOTS_COLORS, ClockSpinnerLoader } from './Loader'
import LoaderBar, { LoadingLayer } from './LoaderBar'
import PlaceholderContainer from './PlaceholderContainer'
export { DotsLoader, DOTS_COLORS, ClockSpinnerLoader, LoaderBar, LoadingLayer, PlaceholderContainer }

export default Loader
